import { render, staticRenderFns } from "./IndexKlaimPp.vue?vue&type=template&id=4f1597d0&"
import script from "./IndexKlaimPp.vue?vue&type=script&lang=js&"
export * from "./IndexKlaimPp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports